import * as environment from '../config/environment';
 
import { BaseAPI } from "./BaseAPI";
import StorageService from "../services/StorageService";
 
import IOtpRequest from '../models/IOtpRequest';
import IVerifyOTPRequest from '../models/IVerifyOTPRequest';
import IVerifyOTP from '../models/IVerifyOTP';
 
 
class AuthAPI extends BaseAPI {
 
  constructor() {
    const baseUrl = environment.API_URL + "Auth";
    super(baseUrl);
  }
  async KullaniciVarMi(otpRequest: SignInRequest) {
    StorageService.clearAll();
    const response = await this.post("KullaniciVarMi", otpRequest, true);
   
    return response.data;
  }

  async ValidatePassword(otpRequest: ValidatePasswordRequest) {
    const response = await this.post("ValidatePassword", otpRequest, true);
    return response.data;
  }

  async signIn(otpRequest: SignInRequest) {
    StorageService.clearAll();
    const response = await this.post("login", otpRequest, true);
    let verifydata = response?.data;
 
    if (response?.success) {
      StorageService.setUserInfo(response?.data);
      StorageService.setAccessToken(verifydata.token);
 
      return response.data;
 
    }else if(response?.success && response?.data.sonuc>0){
      return response.data;
    }
    else{
      return {sonuc:5}
    }
  }
  async LoginSmsControl(otpRequest: SignInRequest) {
    StorageService.clearAll();
    const response = await this.post("LoginSmsControl", otpRequest, true);
   
    return response;
  }
  async signOut() {
 
    const response = await this.get("logout");
    if (response?.success) {
      StorageService.clearAll();
      return true;
    } else {
      return false;
    }
 
  }
  async ProfilGuncelleme(request :UyelikGuncelleRequest  ) {
    const user=StorageService.getUserInfo();
    const response = await this.post("ProfilGuncelleme", request, true);
    let verifydata = response?.data;
    if (response?.success && request.kullaniciId===user.sqId) {
      StorageService.setUserInfo(verifydata);
 
    }
   
    return response;
  }
  sendOtp(otpRequest: IOtpRequest) {
    StorageService.clearAll();
    return this.post("otp", otpRequest, true);
  }
 
  verifyOtp(verifyOTPRequest: IVerifyOTPRequest) {
    return this.post("otp/verify", verifyOTPRequest, true)
      .then(response => {
        let verifydata: IVerifyOTP = response?.data;
        if (response?.success) {
          StorageService.setTahsilatUserInfo(verifydata);
        }
        return response.data;
      });
  }
 
 
}
 
 
export default new AuthAPI();
class SignInRequest {
  userName: string | null;
  vergiNo: string | null;
  password: string;
  girisTuru: string;
  captchaToken: string;
 
  constructor(userName: string | null, vergiNo: string | null, password: string, girisTuru: string, captchaToken: string) {
    this.userName = userName;
    this.vergiNo = vergiNo;
    this.password = password;
    this.girisTuru = girisTuru;
    this.captchaToken = captchaToken;
  }
}
export { SignInRequest };

class ValidatePasswordRequest {
  username?: string | null;
  vergiNo?: string | null;
  oldPassword?: string;
  
  constructor(username?: string | null, vergiNo?: string | null, oldPassword?: string) {
    this.username = username;
    this.vergiNo = vergiNo;
    this.oldPassword = oldPassword;
  }
}
export { ValidatePasswordRequest };

export interface UyelikGuncelleRequest {
  kullaniciId: number;
  adresSqId?: number;
  telefon: number;
  ePosta: string;
  kanGrubu?: string;
  mahalleKodu?: number;
  mahalleAdi?: string;
  caddeSokakKodu?: number;
  caddeSokakAdi?: string;
  ilIlceKodu?: string;
  blokNo?: string;
  kapiNo?: string;
  daireNo?: string;
  siteApartmanAdi?: string;
  postaKodu?: number;
  guncelleyen: string;
  rol?: string;
  aktifMi?: string;
}
 
// interface IVerifyOTP {
//     tcKimlikNo: string;
//     otp: string;
// }
// interface IVerifyOTPRequest {
//     tcKimlikNo: string;
//     otp: string;
// }
// interface IOtpRequest {
//   txnId:string,
//   otp:string,
//   registryNumber:number,
//   subscriberNumber?:number,
// }
 